<template>
  <v-widget title="Aktivitas Terakhir">
    <div slot="widget-content">
      <div
        v-if="!user_loaded"
        class="layout justify-center align-center"
        style="padding: 200px 0"
      >
        <v-progress-circular
          indeterminate
          :size="40"
          :width="2"
          color="secondary"
        >
        </v-progress-circular>
      </div>
      <div v-else-if="activity.length">
        <vue-perfect-scrollbar style="max-height: 430px">
          <v-list two-line dense class="pa-0">
            <v-list-tile
              v-for="(item, index) in simpleActivity"
              avatar
              v-ripple
              :key="`last-activity-${index}`"
              :to="{ name: 'User', query: { id: item.id_user } }"
            >
              <v-list-tile-avatar>
                <img
                  v-lazy="c.PHOTO_PROFIL_URL + item.photo_profil"
                  :alt="item.username"
                />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.role }} -
                  <b>{{ item.username }} </b>
                </v-list-tile-title>
                <v-list-tile-sub-title>{{
                  $moment(
                    item.last_activity,
                    "YYYY-MM-DD HH:mm:ss",
                    true
                  ).isValid()
                    ? item.last_activity
                    : "belum pernah" | moment("from", "now")
                }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </vue-perfect-scrollbar>
        <v-divider></v-divider>
        <v-btn block flat class="ma-0" @click="nToggle">
          {{ nLocal == -1 ? "Sedikit" : "Banyak" }}
          <v-icon>{{
            nLocal == -1 ? "keyboard_arrow_up" : "keyboard_arrow_down"
          }}</v-icon>
        </v-btn>
      </div>
      <div
        v-else
        class="layout justify-center align-center"
        style="padding: 200px 0"
      >
        <h2>Belum ada data.</h2>
        <v-icon medium>sentiment_very_dissatisfied</v-icon>
      </div>
    </div>
  </v-widget>
</template>

<script>
import _ from "lodash";
import c from "@/constants";
import VWidget from "@/components/widgets/VWidget";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapState } from "vuex";

export default {
  name: "last-activity",
  props: {
    n: {
      type: Number,
      default: 5
    }
  },
  components: {
    VWidget,
    VuePerfectScrollbar
  },
  data() {
    return {
      c: c,
      nLocal: -1
    };
  },
  computed: {
    ...mapState("user", ["user", "user_loaded"]),
    activity() {
      let user = this.user.filter(u => {
        return parseInt(u.active_user);
      });
      return _.orderBy(user, "last_activity", "desc");
    },
    simpleActivity() {
      return this.activity.filter((_, i) => i < this.nLocal || this.nLocal < 0);
    }
  },
  methods: {
    nToggle() {
      if (this.nLocal == -1) this.nLocal = _.cloneDeep(this.n);
      else this.nLocal = -1;
    }
  },
  mounted() {
    this.nLocal = _.cloneDeep(this.n);
  }
};
</script>
